import React from 'react'
import { Link } from 'gatsby'

import Title from '../components/common/title'
import ContactForm from '../components/forms/contact'
import PageLayout from '../components/pagelayout'
import SEO from '../components/seo'

const Contact = () => (
  <PageLayout>
    <SEO title="Contact" />
    <Title value="Contact" classes="dark-blue" />
    <ContactForm />
    <div className="body bold margin-top-large">Mailing Address:</div>
    <div className="body">6022 N. Strathbury Ave.</div>
    <div className="body">Kansas City, MO 64151</div>
    <div></div>
    <Link to="/">Go back to the homepage</Link>
  </PageLayout>
)

export default Contact
